import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface HeaderBarProps {
  onClose: () => void;
  pageName: string;
}

const HeaderBar = ({ pageName, onClose }: HeaderBarProps) => (
  <div className="bg-primary sticky top-0 z-10 flex h-[52px] shrink-0 items-center justify-between border-b px-4">
    <Typography.LabelMd weight="semibold">{pageName}</Typography.LabelMd>
    <button
      type="button"
      className="flex h-5 w-5 items-center justify-center"
      onClick={onClose}
    >
      <Icon type="16-cross" size={16} />
    </button>
  </div>
);

export default HeaderBar;
